import { getThumbnailObject, getThumbnailImage } from './thumbnail'
export default { getThumbnailObject, getThumbnailImage }
